import { useEffect, useState } from 'react';
import { gamificationService } from '../services/gamificationService';
import { useAuth } from '../context/AuthContext';

export default function useGamification() {
  const { user } = useAuth();
  const [xp, setXP] = useState(0);
  const [level, setLevel] = useState(1);
  const [streak, setStreak] = useState(0);
  const [coins, setCoins] = useState(0);
  const [achievements, setAchievements] = useState([]);
  const [quests, setQuests] = useState([]);
  const [badges, setBadges] = useState([]);
  const [storeItems, setStoreItems] = useState([]);

  useEffect(() => {
    if (!user) return;
    gamificationService.getUserXP(user.uid).then((data) => {
      setXP(data.xp || 0);
      setLevel(data.level || 1);
      setStreak(data.streak || 0);
      setCoins(data.coins || 0);
    });
    gamificationService.getAchievements(user.uid).then(setAchievements);
    gamificationService.getQuests(user.uid).then(setQuests);
    gamificationService.getBadges(user.uid).then(setBadges);
    gamificationService.getStoreItems().then(setStoreItems);
  }, [user]);

  return {
    xp,
    level,
    streak,
    coins,
    achievements,
    quests,
    badges,
    storeItems,
  };
}
